<script>
  import {
    faArrowLeft,
    faArrowRight,
    faUser,
    faUsers,
  } from "@fortawesome/pro-regular-svg-icons";
  import { _ } from "../stores/index";
  import {
    Flex,
    FlexItem,
    TextField,
    Button,
    Icon,
    Checkbox,
  } from "@gl/design-system";
  import { getContext, onMount } from "svelte";
  import { parseUrl, setUrl } from "../utils/index";
  const { isAuthorized } = getContext("isAuthorized");

  export let data;
  export let disabled;
  export let checkboxes = true;
  export let resource = "members";

  const initialData = { ...data };

  let search = { current: "", available: "" };
  let searched = {};
  let selected = {
    current: [],
    available: [],
  };

  let display = {
    user: true,
    group: true,
  };

  const handleAssignmentClick = (table, resource) => {
    if (selected[table].some((r) => resource.id === r.id)) {
      selected[table] = selected[table].filter((e) => e.id !== resource.id);
    } else {
      selected[table] = [...selected[table], resource];
    }
  };

  const handleAddRemove = (type) => {
    const originalColumn = type === "add" ? "available" : "current";

    const destinationColumn = type === "add" ? "current" : "available";

    if (selected[originalColumn].length) {
      data[destinationColumn] = [
        ...data[destinationColumn],
        ...selected[originalColumn],
      ];
      data[originalColumn] = data[originalColumn].filter(
        (e) => !selected[originalColumn].some((el) => el.id === e.id),
      );

      if (searched[destinationColumn])
        searched[destinationColumn] = [
          ...searched[destinationColumn],
          ...selected[originalColumn],
        ];

      if (searched[originalColumn])
        searched[originalColumn] = searched[originalColumn].filter(
          (e) => !selected[originalColumn].some((el) => el.id === e.id),
        );
    }
    selected = {
      current: [],
      available: [],
    };
  };

  const handleSearch = (type) => {
    searched[type] = data[type].filter((m) =>
      m.label.toUpperCase().includes(search[type].toUpperCase()),
    );
  };

  const handleCheckbox = () => {
    for (const type of ["current", "available"]) {
      searched[type] = data[type].filter((el) => {
        return !Object.entries(display).some(([displayType, value]) => {
          return !value && el.type === displayType;
        });
      });
    }

    setUrl({
      showUsers: String(display.user),
      showGroups: String(display.group),
    });
  };

  export function reset() {
    data = { ...initialData };
    display.group = true;
    display.user = true;
  }

  export function getCurrent() {
    const selected = {
      all: data.current.flatMap((m) => m.id),
    };

    for (const c of data.current) {
      if (c.type && selected[c.type]) {
        selected[c.type].push(c.id);
      } else if (c.type) {
        selected[c.type] = [c.id];
      }
    }

    return selected;
  }

  onMount(() => {
    const query = parseUrl(window.location.search);

    if (query.showUsers === "true" || query.showUsers === "false") {
      display.user = query.showUsers === "true";
    }
    if (query.showGroups === "true" || query.showGroups === "false") {
      display.group = query.showGroups === "true";
    }

    if (!display.user || !display.group) {
      handleCheckbox();
    }
  });
</script>

{#if checkboxes}
  <Flex class="my-2 align-items-center">
    <FlexItem class="mr-4 mt-2">
      <b>{$_("common.show")}</b>
    </FlexItem>
    {#if $isAuthorized("group_read")}
      <FlexItem class="mr-2">
        <Checkbox
          bind:value={display.group}
          label={$_("common.groups")}
          on:change={handleCheckbox}
        />
      </FlexItem>
    {/if}
    <FlexItem>
      <Checkbox
        bind:value={display.user}
        label={$_("common.users")}
        on:change={handleCheckbox}
      />
    </FlexItem>
  </Flex>
{/if}

<div class="grid-container">
  {#each ["current", "available"] as type, index}
    <div class="all">
      <div class="header mb-2" style="height:75px">
        <Flex class="mt-4 align-items-center">
          <FlexItem class="mr-6">
            <h4 class="gl-title level-4" style="width: max-content;">
              {$_(`${resource}.${type}`)}
            </h4>
          </FlexItem>
          <FlexItem class="flex-grow-1">
            <TextField
              variant="Search"
              bind:value={search[type]}
              on:input={() => handleSearch(type)}
            />
          </FlexItem>
        </Flex>
      </div>
      <div class="assignment-container mt-2">
        {#if searched[type]?.length || (!searched[type] && data[type].length)}
          {#each searched[type] || data[type] as el}
            <button
              class={selected[type].includes(el)
                ? "assignment-item-selected"
                : "assignment-item"}
              class:newly-added={!initialData[type].includes(el)}
              on:click={() => !disabled && handleAssignmentClick(type, el)}
              tabindex="0"
            >
              <div>
                {#if el?.type === "user"}
                  <Icon icon={faUser} />
                {:else if el?.type === "group"}
                  <Icon icon={faUsers} />
                {/if}

                <span>
                  {el.label}
                </span>
              </div>

              <div class="assignment-item-info">
                {el.info}
              </div>
            </button>
          {/each}
        {:else}
          <div class="assignment-item">{$_("common.no.display")}</div>
        {/if}
      </div>
    </div>
    {#if index === 0}
      <div class="buttons">
        <Flex class="flex-direction-column mt-3">
          <Button
            outlined
            class="mb-2"
            on:click={() => handleAddRemove("add")}
            disabled={disabled || selected.available.length === 0}
          >
            <Icon icon={faArrowLeft} scale={0.9} />
            <span style="font-size:14px">{$_("buttons.add")}</span>
          </Button>
          <Button
            outlined
            on:click={() => handleAddRemove("remove")}
            disabled={disabled || selected.current.length === 0}
          >
            <span style="font-size:14px">{$_("buttons.remove")}</span>
            <Icon icon={faArrowRight} scale={0.9} />
          </Button>
        </Flex>
      </div>
    {/if}
  {/each}
</div>

<style>
  .grid-container {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: 43% 10% 43%;
    grid-column-gap: 2%;
  }

  .all {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  /* Pin the 75px header. The list below is `flex: 0 1 auto`, so when its content overflows
     the column, flex distributes the shrinkage over every shrinkable sibling in proportion
     to its basis - this header included. Its automatic minimum size stops it well short of
     collapsing, but the search row must not move at all, so opt it out entirely. */
  .header {
    flex: none;
  }

  @media (max-width: 1500px) {
    .grid-container {
      grid-template-columns: 100%;
      flex: none;
    }

    .assignment-container {
      flex: none;
      max-height: 400px;
    }
  }

  .assignment-container {
    border: 1px solid var(--gl-border);
    box-shadow: 0px 8px 16px -2px #0000001a;
    box-shadow: 0px 0px 0px 1px #00000005;
    border-radius: 8px;
    width: 100%;
    background-color: var(--gl-scheme-main);
    /* Height follows the content (`0 1 auto`), so a short list draws a short box instead
       of an expanse of empty background - but it still shrinks into the space left below
       the header and scrolls internally once the list is longer than that. `min-height: 0`
       is what permits shrinking below the content height. */
    flex: 0 1 auto;
    min-height: 0;
    overflow-y: auto;
  }

  .assignment-item,
  .assignment-item-selected {
    min-height: 52px;
    width: 100%;
    border-style: solid;
    border-color: var(--gl-border);
    border-width: 0px 0px 1px 0px;
    background-color: var(--gl-scheme-main);
    text-align: left;
    padding: 8px 16px 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: var(--gl-text);
  }

  .assignment-item :global(.gl-icon),
  .assignment-item-selected :global(.gl-icon) {
    color: var(--gl-text-light);
    margin-right: 10px;
  }

  .assignment-item-selected :global(.gl-icon) {
    color: var(--gl-text-light);
    margin-right: 10px;
  }

  .assignment-item:hover {
    color: var(--gl-scheme-main);
    background-color: var(--gl-primary);
    cursor: pointer;
  }

  .assignment-item:hover > * {
    color: var(--gl-scheme-main);
  }

  .assignment-item:focus {
    border-width: 1px 1px 1px 1px;
  }

  .assignment-item-selected {
    background: var(--gl-dark);
    color: var(--gl-white);
  }

  .assignment-item-info {
    color: var(--gl-text-light);
    justify-self: end;
    max-width: 50%;
    text-align: end;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .assignment-item-selected > .assignment-item-info {
    color: var(--gl-white);
  }

  .assignment-container :first-child {
    border-radius: 8px 8px 0px 0px;
  }

  .assignment-container :only-child {
    border-radius: 8px 8px 8px 8px;
  }

  .assignment-container :last-child {
    border-radius: 0px 0px 8px 8px;
  }

  @media (min-width: 1500px) {
    .buttons {
      margin-top: 90px;
    }
  }

  .newly-added {
    background-color: var(--gl-scheme-main-bis);
  }

  .newly-added.assignment-item-selected {
    background: var(--gl-dark);
    color: var(--gl-white);
  }
</style>
